export const sortOptions = {
    noSort: -1,
    nameAsc: 1,
    nameDesc: 2,
    titleAsc: 3,
    titleDesc: 4
};

const optionToSortBy: sortBy = {
    [sortOptions.noSort]: null,
    [sortOptions.nameAsc]: 'string1',
    [sortOptions.nameDesc]: 'string1',
    [sortOptions.titleAsc]: 'string2',
    [sortOptions.titleDesc]: 'string2'
};
interface sortBy {
    [key: number]: 'string1' | 'string2';
}
export function getSortBy(sortOption): 'string1' | 'string2' {
    return optionToSortBy[sortOption];
}

const optionToIsDesc = {
    [sortOptions.noSort]: null,
    [sortOptions.nameAsc]: false,
    [sortOptions.nameDesc]: true,
    [sortOptions.titleAsc]: false,
    [sortOptions.titleDesc]: true
};

export function getIsDesc(sortOption) {
    return optionToIsDesc[sortOption];
}

export function getSortOption(sortBy, isDesc) {
    let option = sortOptions.noSort;
    if (sortBy === 'string1') {
        if (isDesc) {
            option = sortOptions.nameDesc;
        } else {
            option = sortOptions.nameAsc;
        }
    } else if (sortBy === 'string2') {
        if (isDesc) {
            option = sortOptions.titleDesc;
        } else {
            option = sortOptions.titleAsc;
        }
    }
    return option;
}

export function getNextSortDirection(sortByVal, currentSortBy, isDesc) {
    let nextSortDir: 'asc' | 'desc' = null;
    if (sortByVal !== currentSortBy) {
        nextSortDir = 'asc';
    } else {
        if (!currentSortBy) {
            nextSortDir = 'asc';
        } else if (isDesc) {
            nextSortDir = null;
        } else {
            nextSortDir = 'desc';
        }
    }
    return nextSortDir;
}

export function getNextSortBy(sortByVal, currentSortBy, isDesc) {
    let sortByNext = sortByVal;
    if (currentSortBy && sortByVal === currentSortBy && isDesc) {
        sortByNext = null;
    }
    return sortByNext;
}
